export default "__VITE_ASSET__DKvoBLCu__"